import React, { useEffect, useMemo, useRef, useState } from "react";
import LoadingPage from "../Loading/loading";
import { Cookies } from "react-cookie";
import { BiSolidUser, BiSolidHome, BiPhoneCall } from "react-icons/bi";
import { BsChevronDown } from "react-icons/bs";
import { FaFan } from "react-icons/fa";
import DatePicker from "react-datepicker";
import { FaRegEdit } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import {
  addActionForLead,
  assignMass,
  createBulk,
  getAllCompaniesLeads,
  getAllLeads,
  getChannelsAndProjects,
  getLeadsByType,
  getUsersLeads,
  selfAssign,
  updateLead,
} from "../../network/api/leads";
import { getAllUsers } from "../../network/api/freelance";
import { getAllActions } from "../../network/api/actions";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const ImportLeadsPage = () => {
  const cookie = new Cookies();
  const [channelsAndProjects, setChannelsAndProjects] = useState(null);
  const [leadsSelected, setLeadsSelected] = useState([]);
  const [loading, setLoading] = useState(false);
  const [leads, setLeads] = useState([]);
  const [leadData, setLeadData] = useState(null);
  const [showEditPopup, setEditShowPopup] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [formData, setFormData] = useState({
    project: "",
    channel: "",
  });

  const containerRef = useRef();

  const handleSelect = (index) => {
    if (leadsSelected.includes(index)) {
      setLeadsSelected(leadsSelected.filter((i) => i !== index));
    } else {
      setLeadsSelected([...leadsSelected, index]);
    }
  };

  useEffect(() => {
    getChannelsAndProjects().then((result) => {
      setChannelsAndProjects(result.data);
    });
  });

  const downloadExcel = () => {
    const data = [
      {
        Name: "",
        Phone: "",
        Info: "",
        Destination: "",
      },
    ];

    const worksheet = XLSX.utils.json_to_sheet(data);

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Template");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const file = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    saveAs(file, "Leads_Template.xlsx");
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];

    const reader = new FileReader();

    reader.onload = (event) => {
      const workbook = XLSX.read(event.target.result, {
        type: "binary",
      });

      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      const jsonData = XLSX.utils.sheet_to_json(sheet);

      setLeads(jsonData);
    };

    reader.readAsBinaryString(file);
  };

  const handleChange = (e) => {
    e.target.setCustomValidity("");
    const { name, value } = e.target;
    setLeadData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleClose = () => {
    setEditShowPopup(false);
    setLeadData(null);
    setSelectedIndex(null);
  };

  const handleEdit = (e) => {
    e.preventDefault();

    setLeads((prev) =>
      prev.map((lead, index) => (index === selectedIndex ? leadData : lead)),
    );

    handleClose();

    toast.success("Lead Updated Successfully");
  };

  const handleDeleteSelected = () => {
    setLeads((prev) =>
      prev.filter((_, index) => !leadsSelected.includes(index)),
    );

    setLeadsSelected([]);

    toast.success("Selected leads deleted successfully");
  };

  const handleSubmit = () => {
    setLoading(true);
    const updatedLeads = leads.map((lead) => ({
      ...lead,
      Project: formData.project,
      Channel: formData.channel,
    }));
    createBulk({ data: updatedLeads }).then((result) => {
      if (result.data.message === "Added Done") {
        toast.success(result.data.message, {
          position: "top-right",
        });
        setLeadsSelected([]);
        setLoading(false);
        setLeads([]);
        setLeadData(null);
        setEditShowPopup(false);
        setSelectedIndex(null);
      } else {
        toast.error(result.data.message, {
          position: "top-right",
        });
      }
      setLoading(false);
    });
  };

  return (
    <>
      {loading === true || !channelsAndProjects ? (
        <LoadingPage />
      ) : (
        <div className="channel-page">
          {/* HEADER */}
          <div className="page-header">
            <button className="assignbtn" onClick={downloadExcel}>
              Download Template
            </button>

            {leads.length === 0 && (
              <label htmlFor="excel-upload" className="assignbtn">
                Upload Excel
              </label>
            )}

            <input
              id="excel-upload"
              type="file"
              accept=".xlsx,.xls"
              onChange={handleFileUpload}
              style={{ display: "none" }}
            />

            {leads.length > 0 && formData.project && formData.channel && (
              <button className="assignbtn" onClick={handleSubmit}>
                Add {leads.length} Leads
              </button>
            )}

            {leadsSelected.length > 0 && (
              <button className="assignbtn" onClick={handleDeleteSelected}>
                Delete {leadsSelected.length} Leads
              </button>
            )}
          </div>
          {leads.length > 0 && (
            <div
              className="choices-container"
              style={{ justifyContent: "center" }}
            >
              <div className="form-group" style={{ width: "25%" }}>
                <label htmlFor="region">Project</label>
                <select
                  className="form-select form-control form-select-lg border border-dark"
                  aria-label="Select Project"
                  name="project" // Changed from type2 to be more descriptive
                  value={formData.project}
                  onChange={(e) => {
                    e.target.setCustomValidity("");
                    setFormData({
                      ...formData,
                      project: e.target.value,
                    });
                  }}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    fontSize: "16px",
                    backgroundColor: "#fff",
                    cursor: "pointer",
                  }}
                  required
                  onInvalid={(e) =>
                    e.target.setCustomValidity("Project is required")
                  }
                >
                  <option disabled value="">
                    Select Project
                  </option>
                  {channelsAndProjects.projects?.map((item, index) => (
                    <option key={index} value={item.name}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group" style={{ width: "25%" }}>
                <label htmlFor="channel">Channel</label>
                <select
                  className="form-select form-control form-select-lg border border-dark"
                  aria-label="Select Channel"
                  name="channel" // Changed from type2 to be more descriptive
                  value={formData.channel}
                  onChange={(e) => {
                    e.target.setCustomValidity("");
                    setFormData({
                      ...formData,
                      channel: e.target.value,
                    });
                  }}
                  style={{
                    width: "100%",
                    padding: "10px",
                    border: "1px solid #ddd",
                    borderRadius: "6px",
                    fontSize: "16px",
                    backgroundColor: "#fff",
                    cursor: "pointer",
                  }}
                  required
                  onInvalid={(e) => e.target.setCustomValidity("Channel")}
                >
                  <option disabled value="">
                    Select Channel
                  </option>
                  {channelsAndProjects.channels?.map((item, index) => (
                    <option key={index} value={item.name}>
                      {item.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}
          <div className="page-header">
            <h2>Import Leads</h2>
            <span>{leads.length || 0} Leads</span>
          </div>

          {/* DESKTOP TABLE */}
          <div className="table-scroll">
            <div className="table-container">
              <table className="modern-table">
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>Edit</th>
                    <th>Name</th>
                    <th>Phone</th>
                    <th>Info</th>
                    <th>Destination</th>
                    <th>Channel</th>
                    <th>Project</th>
                  </tr>
                </thead>

                <tbody>
                  {leads?.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          id="check"
                          type="checkbox"
                          checked={leadsSelected.includes(index)}
                          onChange={() => {
                            handleSelect(index);
                          }}
                        />
                      </td>
                      <td>
                        <FaRegEdit
                          onClick={() => {
                            setLeadData(item);
                            setSelectedIndex(index);
                            setEditShowPopup(true);
                          }}
                        />
                      </td>
                      <td>{item?.Name}</td>
                      <td>{item?.Phone}</td>
                      <td>{item?.Info}</td>
                      <td>{item?.Destination}</td>
                      <td>{formData?.channel}</td>
                      <td>{formData?.project}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
      {showEditPopup && (
        <div className="popup-overlay">
          <div
            className="popup-box popup-animation"
            onClick={(e) => e.stopPropagation()}
          >
            {/* HEADER */}
            <div className="popup-header">
              <h2>Edit</h2>
              <button className="close-btn" onClick={handleClose}>
                ✕
              </button>
            </div>

            <form onSubmit={handleEdit}>
              <div className="choices-container">
                <div className="form-group">
                  <label htmlFor="Name">Name</label>
                  <input
                    type="text"
                    id="Name"
                    name="Name"
                    value={leadData.Name}
                    onChange={handleChange}
                    placeholder="Enter Name"
                    required
                    onInvalid={(e) =>
                      e.target.setCustomValidity("Name is required")
                    }
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="Info">User Info</label>
                  <input
                    type="text"
                    id="Info"
                    name="Info"
                    value={leadData.Info}
                    onChange={handleChange}
                    placeholder="Enter User Info"
                    required
                    onInvalid={(e) =>
                      e.target.setCustomValidity("User Info is required")
                    }
                  />
                </div>
              </div>

              <div className="choices-container">
                <div className="form-group">
                  <label htmlFor="Phone">User Phone</label>
                  <input
                    type="text"
                    id="Phone"
                    name="Phone"
                    value={leadData.Phone}
                    onChange={handleChange}
                    placeholder="Enter User Phone"
                    required
                    onInvalid={(e) =>
                      e.target.setCustomValidity("User Phone is required")
                    }
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="Destination">User Destination</label>
                  <input
                    type="text"
                    id="Destination"
                    name="Destination"
                    value={leadData.Destination}
                    onChange={handleChange}
                    placeholder="Enter User Destination"
                    required
                    onInvalid={(e) =>
                      e.target.setCustomValidity("User Destination is required")
                    }
                  />
                </div>
              </div>

              {/* ACTIONS */}
              <div className="popup-actions">
                <button className="cancel-btn" onClick={handleClose}>
                  Cancel
                </button>

                <button className="confirm-btn" type="submit">
                  Edit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      <ToastContainer />
    </>
  );
};

export default ImportLeadsPage;
